import { createSlice } from "@reduxjs/toolkit";

export const terminosSlices = createSlice({
  name: "terminos",
  initialState: {
    value: [],
  },
  reducers: {
    addList: (state, action) => {
      //

      state.value = state.value.concat(action.payload);
    },
    clear: (state, action) => {
      //
      state.value = [];
    },
  },
});

// Action creators are generated for each case reducer function
export const { addList, clear } = terminosSlices.actions;

export default terminosSlices.reducer;
